/* eslint no-console: off */

import '@polymer/paper-dropdown-menu/paper-dropdown-menu.js';

(function () {
    /*
        This is a hack to add auto-validate functionality to paper-dropdown-menu.

        This is based off of: https://github.com/PolymerElements/paper-dropdown-menu/pull/207/
        See: https://github.com/PolymerElements/paper-dropdown-menu/issues/111
             https://github.com/PolymerElements/paper-dropdown-menu/issues/223
    */
    let ELE = customElements.get('paper-dropdown-menu');
    if (ELE && ELE.prototype) ELE = ELE.prototype;
    else {
        console.log('PaperDropdownMenu Hack Failed');
        return;
    }

    // New auto validate code that is being added.
    ELE._doAutoValidate = function (_selectedItem_) {
        const autoValidateName = 'auto-validate';
        if (this.attributes[autoValidateName] && this.attributes[autoValidateName].specified) {
            let valid;
            if (this.validate) {
                valid = this.validate();
            }
            else {
                valid = this.checkValidity();
            }
            this.invalid = !valid;
        }
    };

    // Save original _selectedItemChanged method under new name so it can be used (below) after being replaced.
    ELE._original_selectedItemChanged = ELE._selectedItemChanged;

    // Replace original _selectedItemChanged method with a new one that both calls the original and calls auto validate code.
    ELE._selectedItemChanged = function (selectedItem) {
        this._original_selectedItemChanged(selectedItem);
        this._doAutoValidate(selectedItem);
    };
})();